/* eslint-disable no-underscore-dangle, react/prop-types */
import React, { useCallback, useState } from "react";
import { match as matchPropTypes } from "react-router-prop-types";
import { PROCESSES_SERVICE } from "src/utils/Api";
import DataTableControlled from "src/Components/DataTableControlled";
import { getListingData } from "src/Components/DataTableControlled/utils";
import {
  getDateCell,
  mapValueFromOptions,
} from "src/Components/DataTable/commonCells";
import __ from "src/utils/Translations";
import { DateFilter, SelectFilter } from "src/Components/DataTable/filters";
import { statusOptions } from "src/Pages/Company/ImportsHistory/Utils/importStatuses";
import ActionColumn from "src/Components/DataTable/actionColumn";
import ProcessBar from "./processBar";
import MessageDataPopup from "./messageDataPopup";

export default function ImportsView({ match }) {
  const { importId } = match.params;
  const [dataTable, setDataTable] = useState([]);
  const [count, setCount] = useState(0);
  const [messageData, setMessageData] = useState("");
  const fetchProcessOutputList = useCallback(
    async (filters, page, pageSize, sort) => {
      const { data: newData, count } = await getListingData(
        PROCESSES_SERVICE,
        `/ahr-processes/${importId}/outputs`,
        filters,
        page,
        pageSize,
        sort,
        {
          dateFilters: ["createdAt"],
        },
        []
      );
      let newCount = count;

      const filteredNewData = newData.filter(({ messageType }) => {
        if (messageType === "count") {
          newCount -= 1;
          return false;
        }
        return true;
      });

      if (filteredNewData?.[0]?.step === 0) {
        filteredNewData[0].step = __("Zakończony");
      }

      setDataTable(filteredNewData);
      setCount(newCount);
    },
    [importId]
  );
  return (
    <>
      <ProcessBar processId={importId} onProcessView />
      <DataTableControlled
        id="processedListing"
        service={PROCESSES_SERVICE}
        fetchData={fetchProcessOutputList}
        data={dataTable}
        count={count}
        filterable
        columns={[
          {
            Header: "Wiersz",
            accessor: "step",
          },
          {
            Header: "Typ wiadomości",
            accessor: "messageType",
            Cell: mapValueFromOptions(statusOptions, "messageType"),
            Filter: SelectFilter(statusOptions, true),
          },
          {
            Header: "Wiadomość",
            accessor: "message",
          },
          {
            Header: "Data",
            accessor: "createdAt",
            Filter: DateFilter(true),
            Cell: getDateCell("createdAt", true),
            minWidth: 150,
          },
          {
            Header: "Akcje",
            accessor: "details",
            filterable: false,
            sortable: false,
            Cell: ({ row }) =>
              row._original?.messageData?.message ? (
                <ActionColumn
                  data={row._original}
                  buttons={[
                    {
                      id: "messageData",
                      onClick: () => setMessageData(row._original.messageData),
                      label: "Więcej szczegółów",
                    },
                  ]}
                />
              ) : (
                <>-</>
              ),
          },
        ]}
      />
      {messageData?.message && (
        <MessageDataPopup
          messageData={messageData.message}
          messageParameters={messageData.parameters}
          close={() => setMessageData(null)}
        />
      )}
    </>
  );
}

ImportsView.propTypes = {
  match: matchPropTypes.isRequired,
};
